// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__LMyCX","signatureButtonsRight":"ModalSign_signatureButtonsRight__VJdgk"};